import { useDefaultPreference, useLocalStorage } from '@/util'

export const enableExperimentalSettings = useLocalStorage(
  ['settings', 'enable-experimental'],
  false,
)

export const darkMode = useLocalStorage(['color-scheme', 'dark'], false)

export const timeslotListLimit = useLocalStorage(['timeslotList', 'limit'], 12)
export const scheduleListLimit = useLocalStorage(['scheduleList', 'limit'], 12)
export const episodeListLimit = useLocalStorage(['episodeList', 'limit'], 12)
export const profileListLimit = useLocalStorage(['profileList', 'limit'], 12)

export const weekCalendarSlotResolution = useDefaultPreference(
  useLocalStorage<number | null>(['weekCalendar', 'slotResolution'], null),
  15,
)
